import hardtack from 'hardtack';
import { isHotjarian } from '@hotjar/webapp/utils/isHotjarian';
import * as Sentry from '@sentry/browser';

export const REF_COOKIE_KEY = 'REF';

export const ACC_COOKIE_KEY = 'ACC';

const ACC_HEADER_KEY = 'X-ACC';

type AccessTokenHeader = {
  [ACC_HEADER_KEY]: string;
};

export const getAccessToken = (): string | undefined => {
  return hardtack.get(ACC_COOKIE_KEY);
};

export const getAccessTokenHeaders = (overwrittenAcc?: string): AccessTokenHeader | null => {
  const acc = getAccessToken();

  /**
   * This line is for testing purposes.
   * We show the console.log only the users that have email ends with @hotjar.com.
   */
  if (overwrittenAcc) {
    const isMatched = overwrittenAcc === acc;

    if (!isMatched) {
      const isInternalUser = isHotjarian();
      if (isInternalUser) {
        // eslint-disable-next-line no-console
        console.log(
          acc ? `Tokens are not matched!` : `Tokens are not matched! (Acc cookie is empty)`,
          {
            cookie: acc,
            response: overwrittenAcc,
          },
        );
      }

      Sentry.captureMessage(
        acc ? `Tokens are not matched!` : `Tokens are not matched! (Acc cookie is empty)`,
        {
          extra: {
            cookie: acc,
            response: overwrittenAcc,
            isHotjarian: isInternalUser,
          },
          tags: {
            isHotjarian: isInternalUser,
            issue: 'spontaneous-logout',
          },
        },
      );
    }
  }
  const latestAcc = overwrittenAcc || acc;
  return latestAcc ? { [ACC_HEADER_KEY]: latestAcc } : null;
};
